import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injectable, Inject } from '@angular/core';
import { HttpClientModule, HttpClient }    from '@angular/common/http';
import { FormsModule, ReactiveFormsModule }    from '@angular/forms';

import { DataService } from './data.service'

import { AppRoutingModule } from './/app-routing.module';
import { AuthGuard } from './auth.guard';

import { MatButtonModule, MatCheckboxModule, MatSidenavModule, MatDialogModule, 
  MatInputModule, MatTableModule, MatPaginatorModule, MatSortModule,
  MatSelectModule, MatOptionModule, MatDatepickerModule, MatNativeDateModule,
  MatRadioModule, MatSlideToggleModule, MatSliderModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule, GoogleMapsAPIWrapper, MapsAPILoader, LazyMapsAPILoaderConfigLiteral, LAZY_MAPS_API_CONFIG, GoogleMapsScriptProtocol } from '@agm/core';
import { WindowRef, DocumentRef } from '@agm/core/utils/browser-globals';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { MenuComponent } from './menu/menu.component';
import { RecuperaMailComponent } from './recupera-mail/recupera-mail.component';
import { PopupComponent } from './paginas/popup/popup.component';
import { InfoUsuarioComponent } from './info-usuario/info-usuario.component';
import { Menu2Component } from './menu2/menu2.component';

import { QRCodeModule } from 'angular2-qrcode';


@Injectable()
export class CustomLazyAPIKeyLoader extends MapsAPILoader {
  private _scriptLoadingPromise: Promise<void>;
  private _config: LazyMapsAPILoaderConfigLiteral;
  private _windowRef: WindowRef;
  private _documentRef: DocumentRef;

  constructor( @Inject(LAZY_MAPS_API_CONFIG) config: any, w: WindowRef, d: DocumentRef, private dataService: DataService) {
      super();
      this._config = config || {};
      this._windowRef = w;
      this._documentRef = d;
  }

  load(): Promise<void> {
      if (this._scriptLoadingPromise) {
          return this._scriptLoadingPromise;
      }

      const script = this._documentRef.getNativeDocument().createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      const callbackName: string = `angular2GoogleMapsLazyMapsAPILoader`;

      this.dataService.getK('GGLAPIK').subscribe((res: any) => {
        //console.log("res")
        //console.log(res[0])
        //console.log(res[0].v)
        this._config.apiKey = res[0].v;
        script.src = this._getScriptSrc(callbackName);
        this._documentRef.getNativeDocument().body.appendChild(script);
    }

      )

      this._scriptLoadingPromise = new Promise<void>((resolve: Function, reject: Function) => {
          (<any>this._windowRef.getNativeWindow())[callbackName] = () => { console.log("loaded"); resolve(); };

          script.onerror = (error: Event) => { reject(error); };
      });

      
      return this._scriptLoadingPromise;
  }

  private _getScriptSrc(callbackName: string): string {
      let protocolType: GoogleMapsScriptProtocol =
          (this._config && this._config.protocol) || GoogleMapsScriptProtocol.HTTPS;
      let protocol: string;

      switch (protocolType) {
          case GoogleMapsScriptProtocol.AUTO:
              protocol = '';
              break;
          case GoogleMapsScriptProtocol.HTTP:
              protocol = 'http:';
              break;
          case GoogleMapsScriptProtocol.HTTPS:
              protocol = 'https:';
              break;
      }

      const hostAndPath: string = this._config.hostAndPath || 'maps.googleapis.com/maps/api/js';
      const queryParams: { [key: string]: string | Array<string> } = {
          v: this._config.apiVersion || '3',
          callback: callbackName,
          key: this._config.apiKey,
          client: this._config.clientId,
          channel: this._config.channel,
          libraries: this._config.libraries,
          region: this._config.region,
          language: this._config.language
      };
      const params: string =
          Object.keys(queryParams)
              .filter((k: string) => queryParams[k] != null)
              .filter((k: string) => {
                  // remove empty arrays
                  return !Array.isArray(queryParams[k]) ||
                      (Array.isArray(queryParams[k]) && queryParams[k].length > 0);
              })
              .map((k: string) => {
                  // join arrays as comma seperated strings
                  let i = queryParams[k];
                  if (Array.isArray(i)) {
                      return { key: k, value: i.join(',') };
                  }
                  return { key: k, value: queryParams[k] };
              })
              .map((entry: { key: string, value: string }) => { return `${entry.key}=${entry.value}`; })
              .join('&');
      return `${protocol}//${hostAndPath}?${params}`;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    MenuComponent,
    RecuperaMailComponent,
    PopupComponent,
    InfoUsuarioComponent,
    Menu2Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatDialogModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatSliderModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot(),
    QRCodeModule    
  ],
  providers: [
    DataService,
    AuthGuard,
    GoogleMapsAPIWrapper,
    {provide: MapsAPILoader, useClass: CustomLazyAPIKeyLoader}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
